import { FormGroup, FormControl, Validators, AbstractControl, FormArray, ValidatorFn } from '@angular/forms';
import { startWith } from 'rxjs';

export const forceAffirmativeValidation: ValidatorFn = (ac: AbstractControl) =>
  ac.value === 'true' ? null : { affirmativeValidation: true };
export const forceNegativeValidation: ValidatorFn = (ac: AbstractControl) =>
  ac.value === 'false' ? null : { negativeValidation: true };

export const createOutsideTaxForm = (options?: { isTaxOutsideValidators?: ValidatorFn[] }) => {
  const taxOutsideControlValidators = [Validators.required];
  if (options?.isTaxOutsideValidators) {
    taxOutsideControlValidators.push(...options.isTaxOutsideValidators);
  }
  const form = new FormGroup({
    isTaxOutsideCountry: new FormControl(null, taxOutsideControlValidators),
  });

  return form;
};

export const appendOutsideTaxForm = ({ to: form, with: instance }: { to: AbstractControl; with: AbstractControl }) => {
  if (form instanceof FormGroup) {
    form.addControl('foreignTaxDetails', instance);
  } else if (form instanceof FormArray) {
    form.push(instance);
  }
};

export const getOutsideTaxFormInstance = ({ from: form }: { from: AbstractControl }) =>
  form.get('foreignTaxDetails') as FormGroup;

export const onOutsideTaxUserInput = ({
  on: form,
  affirmative: yes,
  negative: no,
  any,
}: {
  on: FormGroup;
  affirmative?: (value: any) => void;
  negative?: (value: any) => void;
  any?: (value: any) => void;
}) => {
  const taxForm = getOutsideTaxFormInstance({ from: form });
  return taxForm.valueChanges.pipe(startWith(taxForm.value)).subscribe((formValue) => {
    const { isTaxOutsideCountry: val } = formValue;
    val === 'true' && yes?.(val);
    val === 'false' && no?.(val);
    any?.(val);
  });
};
